import { Injectable } from '@angular/core';
import { SessionManagerService } from './session/session-manager.service';
import { ToolbarService } from 'src/app/features/student/canvas-dashboard/services/toolbar.service';
import { ToastService } from './flash.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CheckSubscriptionExpiration {
  constructor(
    private sessionManagerService: SessionManagerService,
    private toolbarService: ToolbarService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}
  // To Check the Subscription is expired.
  isSubscriptionExpired() {
    const loggedInData = this.sessionManagerService.getLoggedInData();
    console.log('[ExpirationCheck] isSubscriptionExpired called. loggedInData:', loggedInData);
    if (loggedInData?.isFreeAccount) {
      console.log('[ExpirationCheck] User has a free account. Not expired.');
      return false;
    }

    if (loggedInData?.subscriptionProvider === 'google_play') {
      const gpEndDate = loggedInData?.googlePlaySubscriptionEndDate;
      console.log('[ExpirationCheck] User has google_play provider. gpEndDate:', gpEndDate);
      if (gpEndDate) {
        const gpEnd = new Date(gpEndDate);
        const now = new Date();
        console.log('[ExpirationCheck] gpEnd:', gpEnd, 'now:', now);
        if (gpEnd > now) {
          // GP subscription is still active — skip expiry check, do NOT log out
          console.log('[ExpirationCheck] Google Play subscription is still active.');
          return false;
        }
        console.log('[ExpirationCheck] Google Play subscription expired client-side.');
        // GP subscription has expired client-side too — fall through to check
        // if there is any other active subscription (e.g. free trial)
      }
      // gpEndDate missing or expired — fall through to standard check below
    }

    const studentSubscriptionType = this.sessionManagerService.getStudentSubscriptionType();
    const subscriptionInfo = this.sessionManagerService.getSubscriptionInfo();
    const studentLicenseEndDateString = this.sessionManagerService.getStudentLicenseEndDate();
    const subscriptionEndDateString = subscriptionInfo?.subscription?.endDate;

    console.log('[ExpirationCheck] Falling through to standard check.', {
      studentSubscriptionType,
      subscriptionInfo,
      studentLicenseEndDateString,
      subscriptionEndDateString,
    });

    // Convert strings to Date objects
    const subscriptionEndDate = new Date(subscriptionEndDateString);
    const studentLicenseEndDate = new Date(studentLicenseEndDateString);
    const currentDate = new Date();

    // Normalize dates to UTC midnight for day-level comparison
    subscriptionEndDate.setUTCHours(0, 0, 0, 0);
    studentLicenseEndDate.setUTCHours(0, 0, 0, 0);
    currentDate.setUTCHours(0, 0, 0, 0);

    console.log('[ExpirationCheck] Normalized dates:', {
      subscriptionEndDate,
      studentLicenseEndDate,
      currentDate,
    });

    if (
      (studentSubscriptionType == '1' || studentSubscriptionType == '2') &&
      subscriptionEndDate < currentDate &&
      studentLicenseEndDate < currentDate
    ) {
      console.warn('[ExpirationCheck] Standard check failed! Logging out user.');
      this.logoutExpiredAccounts();
      return true;
    }

    console.log('[ExpirationCheck] Standard check passed. Not expired.');
    return false;
  }
  logoutExpiredAccounts() {
    this.translateService.get('ERROR.accountExpired').subscribe((translatedMessage: string) => {
      this.toastService.showError(translatedMessage);
    });
    localStorage.setItem('logout', 'true');
    this.toolbarService.logout();
  }
  handleSubscriptionError(err: any) {
    if (err.status === 560 || err.errorMessage === 'Sorry your free trial has expired.') {
      localStorage.setItem('logout', 'true');
      this.toolbarService.logout();
    }
  }
}
